import { round } from 'lodash';

const getAspectRatioRate = (
  width: number,
  height: number,
  approximation = 2,
): string => {
  return round((height / width) * 100, approximation) + '%';
};

export default getAspectRatioRate;
